import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import "../../config.js";
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import SearchIcon from '@mui/icons-material/Search';
import MoreIcon from '@mui/icons-material/MoreVert';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
const AppHeader = (props) => {
  const [headerTitle, setHeaderTitle] = useState(props.datasource.appMainHeaderTitleStr || '');
  const [headerUrl, setHeaderUrl] = useState(props.datasource.appMainHeaderUrlStr || '');
  const handleClick = (preurl) => {
    var tmp_url = preurl;
    if (tmp_url === undefined || tmp_url === null || tmp_url.length < 1) {
      window.location.href = global.constants.const_url;
    } else {
      window.location.href = tmp_url;
    }
  }
  return (
    <div style={{ flexGrow: 1 }}>
      <AppBar position="static" color="default" style={{ background: global.constants.const_color_bg }} sx={{ height: global.constants.const_default_header_height }}>
        <Toolbar position="fixed" >
          <IconButton
            edge="start"
            style={{ marginRight: 2 }}
            aria-label="open drawer"
            onClick={() => { handleClick(props.datasource.appHeaderUrl) }}
          >
            <ArrowBackIosIcon color="primary" />
          </IconButton>
          <Typography style={{ flexGrow: 1, alignSelf: 'flex-end', paddingTop: 2, paddingBottom: 2, textAlign: 'center' }} variant="h6" color="primary" noWrap>
            {props.datasource.appHeaderTitle}
          </Typography>
          <IconButton aria-label="search" color="primary">
            <SearchIcon color="primary" />
          </IconButton>
          <IconButton aria-label="display more actions" edge="end" color="primary">
            <MoreIcon color="primary" />
          </IconButton>
        </Toolbar>
      </AppBar>
    </div>
  );

}
AppHeader.propTypes = {
  appHeaderUrlStr: PropTypes.string,
  appHeaderTitleStr: PropTypes.string,
  headerTitleStrCreate: PropTypes.func,
}
export default (datasource) => <AppHeader datasource={datasource} />;
